import React, { Component } from 'react';
import autoBind from 'auto-bind';
import ReduxSearchInput from 'components/tools/SearchPage/ReduxSearchInput';
import { setReturnShipmentTrackingNumber, setReturnShipmentCarrier } from 'actions/tools/OrdersSearchActions';
import { loadShippingInformationForReturns } from 'actions/tools/DecisionTree/ReturnActions';
import { SearchPageSelect } from 'components/tools/SearchPage/Search.styles';
import {
  getCurrentDecisionNodeContent,
  getDecisionNodeAtPath,
  getSelectedReturnLabelLink,
  getReturnShipmentTrackingNumber,
  getReturnShipmentCarrier,
} from 'extractFromState';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { returnToPreviousMacroWizardPath } from 'actions/searchActions';
import { NextButton, BackButton } from 'components/common/buttonsComponents';
import {
  LeftSection,
  RightSection,
  StepContainer,
  Link,
  ShippingLabelImage,
  InstructionsText,
  InstructionsTextContainer,
  SubText,
  InputContainer,
  Container,
  InnerContainer,
} from './DTCopyTrackingLinkNode.styles';
import { ActionsButtonsWrapper } from '../../DecisionTree.styles';
import { ShipmentCarrierOptions } from './DTCopyTrackingLinkNodeConstants';

export class DecisionTreeCopyTrackingLinkContainer extends Component {
  constructor(props) {
    super(props);
    autoBind(this);
    this.state = {
      shippoInfoLoading: false,
    };
  }

  async nextButtonAction() {
    this.setState({ shippoInfoLoading: true });
    await this.props.loadShippingInformationForReturns();
    this.setState({ shippoInfoLoading: false });
  }

  handleTackingNumberValueChange(number) {
    this.props.setReturnShipmentTrackingNumber(number);
  }

  handleCarrierSelection(event) {
    this.props.setReturnShipmentCarrier(event.target.value);
  }

  backButtonAction() {
    this.props.returnToPreviousMacroWizardPath();
  }

  render() {
    const { returnShipmentTrackingNumber, returnLabelLink, returnShipmentCarrier } = this.props;

    // only enable buttons if line items are selected
    const enableNextButton =
      returnShipmentCarrier && returnShipmentTrackingNumber && this.state.shippoInfoLoading === false;

    return (
      <Container>
        <InnerContainer>
          <StepContainer>
            <LeftSection>Step 1</LeftSection>
            <RightSection>
              <InstructionsTextContainer>
                <InstructionsText>
                  Click{' '}
                  <Link href={returnLabelLink} target="_blank" rel="noopener noreferrer">
                    here
                  </Link>{' '}
                  to see the return label and find the return confirmation number and carrier
                </InstructionsText>
              </InstructionsTextContainer>
              <SubText>Where to find the return tracking number</SubText>
              <ShippingLabelImage src="/images/shipping-label-instructions.jpeg" alt="shipping label" />
              <SubText marginTop={'12px'}>
                Note that the shipping label might not look exactly as above, but use your best judgement to find the
                correct information.
              </SubText>
            </RightSection>
          </StepContainer>
          <StepContainer>
            <LeftSection>Step 2</LeftSection>
            <RightSection>
              <InputContainer>
                <ReduxSearchInput
                  placeholder="Type return tracking number"
                  messageImg={false}
                  searchValue={returnShipmentTrackingNumber}
                  onChangeFunction={this.handleTackingNumberValueChange}
                />
              </InputContainer>
            </RightSection>
          </StepContainer>
          <StepContainer>
            <LeftSection>Step 3</LeftSection>
            <RightSection>
              <InputContainer>
                <SearchPageSelect onChange={this.handleCarrierSelection} value={returnShipmentCarrier}>
                  {ShipmentCarrierOptions.map((option, index) =>
                    index === 0 ? (
                      <option key={option.key} value={option.value} disabled>
                        {option.label}
                      </option>
                    ) : (
                      <option key={option.key} value={option.value}>
                        {option.label}
                      </option>
                    )
                  )}
                </SearchPageSelect>
              </InputContainer>
            </RightSection>
          </StepContainer>
          <StepContainer>
            <LeftSection>Step 4</LeftSection>
            <RightSection>
              <InstructionsText>Check if the information is correct and then press next.</InstructionsText>
            </RightSection>
          </StepContainer>
        </InnerContainer>
        <ActionsButtonsWrapper>
          <NextButton
            active={enableNextButton}
            disabled={!enableNextButton}
            type="submit"
            onClick={() => this.nextButtonAction()}
          >
            NEXT
          </NextButton>
          <BackButton onClick={() => this.backButtonAction()}>BACK</BackButton>
        </ActionsButtonsWrapper>
      </Container>
    );
  }
}

function mapStateToProps(state) {
  return {
    content: getCurrentDecisionNodeContent(state),
    decisionNode: getDecisionNodeAtPath(state),
    returnLabelLink: getSelectedReturnLabelLink(state),
    returnShipmentTrackingNumber: getReturnShipmentTrackingNumber(state),
    returnShipmentCarrier: getReturnShipmentCarrier(state),
  };
}

const mapDispatchToProps = (dispatch) => {
  return {
    ...bindActionCreators(
      {
        loadShippingInformationForReturns,
        setReturnShipmentTrackingNumber,
        setReturnShipmentCarrier,
        returnToPreviousMacroWizardPath,
      },
      dispatch
    ),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(DecisionTreeCopyTrackingLinkContainer);
